import EmptyFacturasRecurrentes from "assets/facturas_recurrentes.svg"
import { useMemo } from "react"
import Button from "../Button/Button"
import { Icontypes } from "./constants"
import "./styles.scss"

function NoResults({
  iconType,
  title,
  message,
  onClick,
  buttonLabel,
}: $TSMigrationFixMe) {
  const onRenderIcon = useMemo(() => {
    const ICON_GROUP = {
      [Icontypes.recurrentes]: (
        <img
          src={EmptyFacturasRecurrentes}
          alt='facturas-reecurrentes'
        />
      ),
    }

    return ICON_GROUP[iconType]
  }, [iconType])

  return (
    <div className='d-flex flex-column info-main-content mb-4'>
      <div className='mb-2'>{onRenderIcon}</div>
      <div className='d-flex flex-column'>
        <h2 className='empy-title'>{title}</h2>
        <p className='empty-text mt-2'>{message}</p>
        <div className='d-flex justify-content-center mt-2'>
          <Button
            label={buttonLabel}
            variant='contained'
            className='!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-cursor-pointer'
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  )
}

export default NoResults
